import { makeStyles, tokens } from '@fluentui/react-components';

const onRowHoverSelector = '& [data-table-show-on-row-hover="true"]';

export const useStyles = makeStyles({
    row: {
        position: 'relative',
        border: 'none',
        backgroundColor: tokens.colorNeutralBackground1,

        [onRowHoverSelector]: {
            opacity: 0, // hide the cell edit button by default
            transition: `opacity ${tokens.durationFast}`,
            backgroundColor: tokens.colorNeutralBackground1,

            '& svg': {
                fontSize: tokens.fontSizeBase400,
            },
        },

        ':hover': {
            backgroundColor: tokens.colorNeutralBackground1Hover,
            [onRowHoverSelector]: {
                opacity: 1, //show the cell edit button on hover.
                backgroundColor: tokens.colorNeutralBackground1Hover,
            },
        },

        ':active': {
            backgroundColor: tokens.colorNeutralBackground1Pressed,
            [onRowHoverSelector]: {
                backgroundColor: tokens.colorNeutralBackground1Pressed,
            },
        },
    },
    rowNested: {
        backgroundColor: tokens.colorNeutralBackground3,
        [onRowHoverSelector]: {
            backgroundColor: tokens.colorNeutralBackground3,
        },

        ':hover': {
            backgroundColor: tokens.colorNeutralBackground3Hover,
            [onRowHoverSelector]: {
                backgroundColor: tokens.colorNeutralBackground3Hover,
            },
        },

        ':active': {
            backgroundColor: tokens.colorNeutralBackground3Pressed,
            [onRowHoverSelector]: {
                backgroundColor: tokens.colorNeutralBackground3Pressed,
            },
        },
    },
    rowActive: {
        backgroundColor: tokens.colorBrandBackground2,
        [onRowHoverSelector]: {
            backgroundColor: tokens.colorBrandBackground2,
        },

        ':hover': {
            backgroundColor: tokens.colorBrandBackground2Hover,
            [onRowHoverSelector]: {
                backgroundColor: tokens.colorBrandBackground2Hover,
            },
        },

        ':active': {
            backgroundColor: tokens.colorBrandBackground2Pressed,
            [onRowHoverSelector]: {
                backgroundColor: tokens.colorBrandBackground2Pressed,
            },
        },
    },
});
